import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Box, Rating } from '@mui/material';
import { OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { BaseUrl } from '../../../redux/config';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { getSession } from '../../../redux/actions/authActions';
import { rateOrder } from '../../../redux/actions/dbactions/orderActions';
import './Order.scss'; // Ensure this is the correct path to your SCSS file
import commObj from '../../../constants/Common';
import { CustomCard } from '../../CustomCard';
import { CreditCardIcon } from '../../../../assets';
import MenuIcon from '../../../../assets/MenuIcon';

export const OrderCard = ({
  handleShow,
  data,
  dispatch,
  handleVelocityModal, // Add the handleVelocityModal prop
  handleInstrModal,
  handleEditModal,
  handleDeleteShow,
  handleRatingShow, // Add the handleRatingShow prop
  handleGrabShow,
  handleResendShow,
  handleRescheduleShow, // Add the handleRescheduleShow prop
}) => {
  const {
    s_status_cd,
    ord_svc_time,
    ord_svc_date,
    order_num,
    order_dte_tsp,
    order_tot_amt,
    svc_provider_cost_amt,
    svc_provider_local_cost_amt,
    order_status_id,
    order_id,
    sys_ord_active_yn,
    order_by,
    service_user,
    svc_name,
    svc_id,
    svc_rating_num,
    user_profile_id,
    svcf_user_profile_id,
    ord_manager_profile_id,
    o_user_first_name,
    svcf_id,
    svcf_name,
    svcf_rating_num,
    svcf_user_id,
    svc_user_phone_nbr,
    svcf_contact_phone_nbr,
    service_user_phn_nbr,
    user_phone_nbr,
    user_iso_cntry_cde,
    order_discount_amt,
  } = data;

  const { refsdata } = useSelector((state) => state.refstypes);
  const [showMore, setShowMore] = useState(false);
  const { role_id } = getSession(); // Get the role ID from session storage
  const history = useHistory(); // Initialize useHistory hook
  const [rating, setRating] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [url, setUrl] = useState(null);
  const [showIcons, setShowIcons] = useState(false);

  const xchange_rate = refsdata?.usr?.iso_currency_xchng || [];

  useEffect(() => {
    if (url) {
      window.location.href = url;
    }
  }, [url]);
  // Construct postData object
  const postData = {
    order_id: data.order_id,
    ord_svc_date: data.ord_svc_date,
    ord_svc_time: data.ord_svc_time,
    order_dte_tsp: data.order_dte_tsp,
    order_tot_amt: data.order_tot_amt,
    xchange_rate: data.xchange_rate,
    svc_provider_cost_amt: data.svc_provider_cost_amt,
    svc_provider_local_cost_amt: data.svc_provider_local_cost_amt,
    svc_id: data.svc_id,
    order_tot_tax: 0.0,
    order_tot_fees: 0.0,
    order_svcf_id: data.order_svcf_id,
    user_profile_id: data.user_profile_id,
    order_svc_user_id: data.order_svc_user_id,
    order_ship_to_id: 2,
    order_ship_instructions: data.order_ship_instructions || '',
    order_bill_to_id: 2,
    order_status_id: 1,
    sys_user_id: data.user_profile_id,
    role_id: role_id,
    sys_source_ip: '192.168.2.2',
    sys_crte_tsp: data.sys_crte_tsp,
    sys_last_updte_tsp: data.sys_last_updte_tsp,
    sys_ord_active_yn: 'Y',
    stripe_checkout_sess_id: data.stripe_checkout_sess_id,
    svcpay_pi: data.svcpay_pi,
    service_order_line: [
      {
        svc_id: data.svc_id,
        svc_name: data.svc_name,
        svc_qnty_nbr: 1,
        svc_status_id: 1,
        svc_price_amt: data.order_tot_amt,
        svcfee_id: 1,
        sys_user_id: data.user_profile_id,
        sys_ordl_active_yn: 'Y',
        sys_crte_tsp: data.sys_crte_tsp,
        sys_last_updte_tsp: data.sys_last_updte_tsp,
      },
    ],
  };

  // handleSubmit function to handle the payment process
  const handleSubmitPay = async () => {
    const { token } = getSession();
    try {
      setIsSaving(true);
      let response = await axios.post(`${BaseUrl}pay/ps`, postData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      setUrl(response.data.session_url);
      setIsSaving(false);
      return response.data;
    } catch (error) {
      console.error('There was a problem with your Axios request:', error);
    }
  };

  useEffect(() => {
    const initialRating = formatRating(svc_rating_num);
    setRating(initialRating); // Initialize rating with formatted order_num
  }, [svc_rating_num]);

  const description = ''; // replace with actual description field if available
  const green_status = new Set([
    'PAID-OUT',
    'PAID',
    'COMPLETED',
    'ACCEPTED',
    'CHECK-IN',
  ]);
  const red_status = new Set([
    'DECLINED',
    'EXPIRED',
    'FAILED',
    'CANCELLED',
    'UNREACHABLE',
    'PAYMNT-PENDING',
  ]);
  const black_status = new Set(['CONTACTED', 'SUBMITTED']);
  const yellow_status = new Set(['PRICED']);
  const shouldText = description.length > 100;
  const displayText = showMore
    ? description
    : `${description.slice(0, 100)}${shouldText ? '...' : ''}`;
  const serviceText = svc_name != null ? svc_name.slice(0, 50) : svc_name;
  const shouldShowCancelIcon = ![12, 10, 8, 9, 6, 7].includes(order_status_id);
  const shouldEnableRatingIcon = [7].includes(order_status_id);
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const handleShowIcons = () => {
    setShowIcons(!showIcons);
  };

  const handleRating = (rating) => {
    if (order_id) {
      dispatch(rateOrder(order_id, rating));
    }
  };

  const handleAddNewOrder = () => {
    try {
      // Save order details to local storage
      localStorage.setItem('newOrder', JSON.stringify(data));
      // Redirect to order layout page
      history.push(`/dashboard/addorder/orderlayout/`);
    } catch (error) {
      console.error('Error saving new order:', error);
    }
  };

  const ratingChanged = (event, newRating) => {
    const formattedRating = formatRating(newRating);
    setRating(formattedRating);
    data.svc_rating_num = formattedRating;
    handleRatingShow(data.order_id, data.order_svcf_id, formattedRating);
    //handleRating(formattedRating);
  };

  // Function to determine the star color based on the rating value
  const getStarColor = (rating) => {
    if (rating >= 4) return '#4caf50'; // Green for 4-5 stars
    if (rating >= 2) return '#ffeb3b'; // Yellow for 2-3 stars
    return '#f44336'; // Red for 0-1 stars
  };

  // Function to format the rating
  const formatRating = (rating) => {
    return rating % 1 === 0 ? Math.floor(rating) : rating;
  };

  const order_tot_amtf = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(role_id == 4 ? svc_provider_cost_amt : order_tot_amt);
  const svc_provider_local_cost_amtf = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_local_cost_amt);
  const order_discount_amtf = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(order_discount_amt);

  const user_phone_nbrf = commObj.formatPhoneNumber(
    user_phone_nbr,
    user_iso_cntry_cde
  );
  const svc_user_phone_nbrf = commObj.formatPhoneNumber(
    svc_user_phone_nbr,
    'ZWE'
  );
  const service_user_phn_nbrf = commObj.formatPhoneNumber(
    service_user_phn_nbr,
    'ZWE'
  );
  const order_dte_tspf = commObj.convertUTCToLocalTime(order_dte_tsp);
  //console.log('----', order_id, data.order_tot_amt, order_status_id, role_id, shouldShowCancelIcon)
  return (
    <CustomCard className="facility">
      <div
        className="d-flex justify-content-between align-items-start !pb-3 !mb-4"
        style={{ borderBottom: '1px solid #E7E7E9' }}
      >
        <div className="d-flex align-items-center justify-content-center gap-2">
          <div className="min-w-[30px] w-[30px] h-[30px] rounded-5 border-slate-300 align-items-center justify-content-center d-flex bankCard_creditCardIcon">
            <CreditCardIcon />
          </div>
          <div>
            <h6 className="card-title mb-0">Order# : {order_id}</h6>
            {/* <small>#{user_profile_id}</small> */}
          </div>
          <p className="my-auto right-align">
            {green_status.has(s_status_cd.toUpperCase()) ? (
              <span className="green">
                {role_id == 5 && s_status_cd.toUpperCase() == 'PAID-OUT'
                  ? 'COMPLETED*'
                  : s_status_cd.toUpperCase()}
              </span>
            ) : red_status.has(s_status_cd.toUpperCase()) ? (
              <span className="red">{s_status_cd.toUpperCase()}</span>
            ) : black_status.has(s_status_cd.toUpperCase()) ? (
              <span className="black">{s_status_cd.toUpperCase()}</span>
            ) : yellow_status.has(s_status_cd.toUpperCase()) ? (
              <span className="yellow">{s_status_cd.toUpperCase()}</span>
            ) : (
              <span className="brown"> **INVALID**</span>
            )}
          </p>
        </div>
      </div>
      <div>
        {description && (
          <p className="truncate">
            {displayText}
            {shouldText && (
              <span onClick={toggleShowMore}>
                {showMore ? 'Show Less' : 'Show More'}
              </span>
            )}
          </p>
        )}
        <div className="row gap-y-3">
          <div className="d-flex align-items-center">
            <small className="me-2">Provider :</small>
            <p className="truncate mb-0">{'(' + svcf_id + ')' + svcf_name}</p>
          </div>
          {role_id < 4 && (
            <div className="d-flex align-items-center">
              <small className="me-2">Phone # :</small>
              <Icon icon="f7:phone-circle-fill" />
              <p className="truncate mb-0">{svcf_contact_phone_nbr}</p>
            </div>
          )}
          <div className="d-flex align-items-center">
            <small className="me-2">Service :</small>
            <p className="truncate mb-0">{'(' + svc_id + ')' + svc_name}</p>
          </div>
          <div className="col-6">
            <small className="whitespace-nowrap">Order Date :</small>
            <p className="truncate mb-0">{order_dte_tspf}</p>
          </div>
          <div className="col-6">
            <small className="whitespace-nowrap">Appt Date :</small>
            <p className=" mb-0">
              {ord_svc_date} - {ord_svc_time}
            </p>
          </div>
          <div className="col-6">
            <small className="whitespace-nowrap">Total Amount (USD):</small>
            <p className="mb-0">{order_tot_amtf}</p>
          </div>
          {order_discount_amt > 0 && (
            <div className="col-6">
              <div className="sub-title m-0">
                <Icon icon="clarity:child-arrow-line" />
                <small className="whitespace-nowrap">
                  Discount Savings (USD):
                </small>
              </div>
              <p>{order_discount_amtf}</p>
            </div>
          )}
          <div className="col-6">
            <small className="whitespace-nowrap truncate">
              {xchange_rate[0]?.iso_curr_name
                ? 'Local Currency (ZiG)' //xchange_rate[0]?.iso_curr_name
                : 'Price'}
              :
            </small>
            <p className="mb-0">{svc_provider_local_cost_amtf}</p>
          </div>
          <div className="col-6">
            <small className="whitespace-nowrap">Order By :</small>
            <p className="truncate mb-0">
              {'(' + user_profile_id + ')' + order_by}
            </p>
          </div>
          {role_id < 4 && (
            <div className="col-6 d-flex align-items-center">
              <small>Phone#:</small>
              <Icon className="me-2" icon="f7:phone-circle-fill" />
              <p className="truncate mb-0">{user_phone_nbrf}</p>
            </div>
          )}
          <div className="col-6">
            <small className="whitespace-nowrap">Order For(patient) :</small>
            <p className="truncate mb-0">{service_user}</p>
          </div>
          {role_id < 4 && (
            <div className="col-6 d-flex align-items-center">
              <small>Phone#:</small>
              <Icon className="me-2" icon="f7:phone-circle-fill" />
              <p className=" mb-0">{service_user_phn_nbrf}</p>
            </div>
          )}
          {role_id !== 5 && (
            <div className="col-6">
              <small className="whitespace-nowrap">Support Specialist:</small>

              <p className="truncate">
                {ord_manager_profile_id === null
                  ? '*'
                  : '(' + ord_manager_profile_id + ')'}
                {o_user_first_name === null ? '*' : o_user_first_name}
              </p>
            </div>
          )}
        </div>
        <div className="rating-container mb-4">
          <div className="flex gap-2 flex-col xs:flex-row">
            {shouldEnableRatingIcon && role_id !== 4 ? (
              <h4>Rate your experience:</h4>
            ) : role_id === 4 ? (
              <h4>Order rating:</h4>
            ) : (
              <h4>Your rating of this order:</h4>
            )}
            <Box
              sx={{
                '& .MuiRating-iconFilled': {
                  color: getStarColor(rating),
                },
              }}
            >
              <Rating
                name="rating"
                value={rating}
                onChange={ratingChanged}
                size="small"
                readOnly={
                  role_id === 4 || rating > 0 || !shouldEnableRatingIcon
                } // Disable if rating is greater than 0
              />
            </Box>
          </div>
          <div className="subHeading">
            Your rating: {formatRating(rating)} stars
          </div>
        </div>
        <div className="flex justify-end relative">
          <div className="flex gap-3 w-full justify-between">
            <div className="w-full">
              {shouldShowCancelIcon &&
                [13, 14, 1].includes(order_status_id) &&
                data.order_tot_amt > 0 &&
                ![4].includes(role_id) && (
                  <button
                    className="sign_btn w-full"
                    style={{ fontSize: '12px' }}
                    disabled={
                      [13, 14, 1].includes(data.order_status_id) ? false : true
                    }
                    onClick={handleSubmitPay}
                  >
                    {isSaving ? (
                      <>
                        <Spinner animation="border" variant="primary" />
                      </>
                    ) : (
                      'PAY NOW'
                    )}
                  </button>
                )}
            </div>

            <div
              className="border rounded-md w-[15%] flex justify-center items-center cursor-pointer"
              onClick={handleShowIcons}
            >
              <MenuIcon />
            </div>
          </div>

          <div
            className={`${
              showIcons
                ? 'w-fit flex h-auto py-1 bg-white shadow-xl absolute bottom-12 border-red-500 border rounded-md'
                : 'hidden'
            }`}
          >
            <div className="flex flex-col !gap-3 !py-2 !px-3">
              {role_id < 5 && (
                <div
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() => handleVelocityModal(data)}
                >
                  <Icon
                    icon="system-uicons:document"
                    className="!text-red-600 !text-base"
                  />
                  <p className="m-0 !text-xs !text-[#262627] !font-normal">
                    Order Velocity
                  </p>
                </div>
              )}
              {(([1, 3].includes(order_status_id) &&
                Math.round(order_tot_amt) === 0) ||
                [13].includes(order_status_id)) &&
                role_id <= 4 && (
                  <div
                    className="flex gap-2 items-center cursor-pointer"
                    onClick={() => handleEditModal(data)}
                  >
                    <Icon
                      icon="fluent:edit-48-filled"
                      className="!text-red-600 !text-base"
                    />
                    <p className="m-0 !text-xs !text-[#262627] !font-normal">
                      Update Price
                    </p>
                  </div>
                )}
              {role_id < 4 && shouldShowCancelIcon && (
                <div
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() => handleShow(data.order_id, data.order_svcf_id)}
                >
                  <Icon
                    icon="mingcute:close-fill"
                    className="!text-red-600 !text-base"
                  />
                  <p className="m-0 !text-xs !text-[#262627] !font-normal">
                    Cancel Order
                  </p>
                </div>
              )}
              {role_id < 4 && order_status_id !== 7 && shouldShowCancelIcon && (
                <div
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() =>
                    handleDeleteShow(data.order_id, data.order_svcf_id)
                  }
                >
                  <Icon
                    icon="mingcute:delete-fill"
                    className="!text-red-600 !text-base"
                  />
                  <p className="m-0 !text-xs !text-[#262627] !font-normal">
                    Delete Order
                  </p>
                </div>
              )}
              {role_id !== 4 && shouldShowCancelIcon && (
                <div
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() =>
                    handleRescheduleShow(
                      data.order_id,
                      service_user,
                      ord_svc_date,
                      ord_svc_time
                    )
                  }
                >
                  <Icon
                    icon="mingcute:calendar-fill"
                    className="!text-red-600 !text-base"
                  />
                  <p className="m-0 !text-xs !text-[#262627] !font-normal">
                    Reschedule Order
                  </p>
                </div>
              )}
              {role_id < 4 &&
                !data.ord_manager_profile_id &&
                shouldShowCancelIcon && (
                  <div
                    className="flex gap-2 items-center cursor-pointer"
                    onClick={() =>
                      handleGrabShow(data.order_id, data.order_svcf_id)
                    }
                  >
                    <Icon
                      icon="fa:hand-grab-o"
                      className="!text-red-600 !text-base"
                    />
                    <p className="m-0 !text-xs !text-[#262627] !font-normal">
                      Claim Order
                    </p>
                  </div>
                )}
              {role_id < 4 && shouldShowCancelIcon && (
                <div
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() =>
                    handleResendShow(data.order_id, data.order_svcf_id)
                  }
                >
                  <Icon
                    icon="majesticons:chat-text-line"
                    className="!text-red-600 !text-base"
                  />
                  <p className="m-0 !text-xs !text-[#262627] !font-normal">
                    Resend Messages
                  </p>
                </div>
              )}

              {data.order_ship_instructions && (
                <div
                  className="flex gap-2 items-center cursor-pointer"
                  onClick={() => handleInstrModal(data)}
                >
                  <Icon
                    icon="icon-park-outline:attention"
                    className="!text-red-600 !text-base"
                  />
                  <p className="m-0 !text-xs !text-[#262627] !font-normal">
                    Special Instructions
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex gap-2 mt-2">
          {[7, 12].includes(order_status_id) && (
            <div className="w-full flex items-center gap-1 text-primary-blue">
              <Icon icon="tabler:hand-finger-right" />

              <a
                href="#"
                className="underline-link text-[13px] font-medium"
                style={{ textDecoration: 'underline' }}
                onClick={handleAddNewOrder}
              >
                Place NEW ORDER for same patient
              </a>
            </div>
          )}
        </div>
      </div>
    </CustomCard>
  );
};
